import {
    COMMAND_PRIORITY_LOW,
    createCommand, LexicalCommand,
    LexicalNode
} from "lexical"
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext"
import {mergeRegister} from "@lexical/utils"
import {useEffect} from "react"
import toggleFontColor from "./action/toggle-font-color"
import {FontColorNode} from "./node/font-color-node"

export enum FontColorType {
    LIGHT_BLUE  = 'font-color-light-blue',
    DARK_BLUE   = 'font-color-dark-blue',
    GREEN       = 'font-color-green',
    YELLOW      = 'font-color-yellow',
    ORANGE      = 'font-color-orange',
    RED         = 'font-color-red',
    MAGENTA     = 'font-color-magenta',
    PURPLE      = 'font-color-purple',
    BROWN       = 'font-color-brown',
    GRAY        = 'font-color-gray',
}

export const INSERT_FONT_COLOR_COMMAND: LexicalCommand<FontColorType | null> = createCommand('insertFontColor')

const debug = false
// const debug = "FontColorPlugin"

export function FontColorPlugin(): null {
    const [editor] = useLexicalComposerContext()

    useEffect(() => {
        // check if node is added to config and show warning if not
        if (!editor.hasNodes([FontColorNode])) {
            throw new Error('FontColorPlugin: FontColorNode is not registered on editor')
        }
        return mergeRegister(
            editor.registerCommand(
                INSERT_FONT_COLOR_COMMAND,
                (fontColorType:FontColorType | null) => {
                    toggleFontColor(fontColorType)
                    return true
                },
                COMMAND_PRIORITY_LOW,
            )
        )
    }, [editor])

    return null
}

// lexical convention function
export function $createFontColorNode(type: FontColorType): FontColorNode {
    return new FontColorNode(type)
}

// lexical convention function
export function $isFontColorNode(
    node: LexicalNode | null | undefined,
): node is FontColorNode {
    return node instanceof FontColorNode;
}